module.exports = __webpack_public_path__ + "images/application/i-info-35420193.svg";